module.exports = __webpack_public_path__ + "media/images/countrysquared/sg-860e2b1f0c1d42eec6e46cc8b5388ca2.svg";